import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared.module';

@Component({
	selector: 'bt-upload-modal',
	standalone: true,
	imports: [MatDialogModule, MatIconModule, FormsModule, MatFormFieldModule, MatButtonModule, MatInputModule, MatCheckboxModule, MatChipsModule, CommonModule, SharedModule],
	templateUrl: './upload-modal.component.html',
	styleUrl: './upload-modal.component.scss'
})
export class UploadModalComponent {
	readonly #dialogRef = inject(MatDialogRef<UploadModalComponent>);
	readonly data = inject(MAT_DIALOG_DATA);

	format = '{StyleCode}{TeamCode}{ColorCode}_{CodiceUtilizzoCodificato}_{AspectRatio}.{FileExtension}';
	files: Array<File> = [];
	previewUrls: Array<string> = [];

	// onDragStart(ev: any) {
		// this.tmpShot = s;
		// const sub = defer(() => fromEvent(ev.target as HTMLElement, 'dragend'))
		//   .pipe(takeUntilDestroyed(this.#destroyRef))
		//   .subscribe(() => {
		// 	this.onDragEnd();
		// 	sub.unsubscribe();
		//   });
		// this.inDragging = true;
		// const ghostEl = ev.target.cloneNode(true) as HTMLElement;
		// if (ghostEl && ghostEl.style) {
		//   ghostEl.style.opacity = '0';
		//   ghostEl.style.display = 'none';
		//   ev.dataTransfer.setDragImage(ghostEl, 0, 0);
		// }
		// setTimeout(() => { this.elementInDrag = document.getElementById(this.elementInDragId); });
	//   }

	onDropZoneDragOver(event: DragEvent) {
		event.preventDefault();
		event.stopPropagation();
		// this.dropzoneActive = true;
	}

	// onDropZoneDragLeave(event: DragEvent) {
	// 	event.preventDefault();
	// 	event.stopPropagation();
	// 	// this.dropzoneActive = false;
	// }

	onDropZoneDrop(event: DragEvent) {
		event.preventDefault();
		event.stopPropagation();
		// this.dropzoneActive = false;
		const files = event.dataTransfer?.files;
		if (files && files.length > 0) {
			this.handleFiles(files);
		}
	}

	onFileSelected(event: Event) {
		const input = event.target as HTMLInputElement;
		const files = input.files;
		if (files && files.length > 0) {
			this.handleFiles(files);
		}
	}

	private handleFiles(files: FileList): void {
		this.files = Array.from(files);
		this.files = this.data.single ? [this.files[0]] : this.files;
		this.updatePreview();
	}

	private updatePreview(): void {
		this.files.forEach(file => {
			this.previewUrls.push(URL.createObjectURL(file));
		});
	}

	onClose(): void {
		this.#dialogRef.close();
	}

}
